/* Video */
'use strict';

(function ($, Drupal) {
  Drupal.behaviors.Video = {
    attach: function (context) {
      $('.section.video', context).each(function () {
        var figure = $('figure', this);
        var player = $('iframe', figure);
        if (player.length > 0) {
          $('button', figure).on('click', function () {
            figure.addClass('playing');
            var url = player.attr('src');
            var newurl = url.replace('autoplay=0', 'autoplay=1');
            player.attr('src', newurl);
          });
        }
      });
    }
  };
})(jQuery, Drupal);
